module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-btn",
    class: {
      nolabel: !_vm.isLabelVisible
    }
  }, [_c('button', {
    staticClass: "c-light h6 regular step-decrease",
    class: {
      disable: _vm.index === 0
    },
    on: {
      "mousedown": function($event) {
        _vm.start('decrease')
      },
      "mouseup": _vm.stopAction,
      "touchstart": function($event) {
        _vm.start('decrease')
      },
      "touchend": _vm.stopAction
    }
  }, [(!_vm.isarrow) ? _c('span', [_vm._v("-")]) : _c('img', {
    attrs: {
      "src": "/images/arrow-step.svg"
    }
  })]), _vm._v(" "), (_vm.isLabelVisible) ? _c('span', {
    staticClass: "c-dark regular h6 bg-light"
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "c-light h6 regular step-increment",
    class: {
      disable: _vm.index === _vm.steps.length - 1
    },
    on: {
      "mousedown": function($event) {
        _vm.start('increment')
      },
      "mouseup": _vm.stopAction,
      "touchstart": function($event) {
        _vm.start('increment')
      },
      "touchend": _vm.stopAction
    }
  }, [(!_vm.isarrow) ? _c('span', [_vm._v("+")]) : _c('img', {
    attrs: {
      "src": "/images/arrow-step.svg"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4fa9600"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/StepBtn.vue
// module id = 663
// module chunks = 0